import { render, staticRenderFns } from "./maintain.vue?vue&type=template&id=134bb67d&scoped=true&"
import script from "./maintain.vue?vue&type=script&lang=js&"
export * from "./maintain.vue?vue&type=script&lang=js&"
import style0 from "./maintain.vue?vue&type=style&index=0&id=134bb67d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134bb67d",
  null
  
)

export default component.exports